import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { left } from 'utils';

export const StyledAparatVideo = styled('div')(
  () => css`
    position: relative;

    .ratio {
      display: block;
      width: 100%;
      height: auto;
    }

    iframe {
      position: absolute;
      top: 0;
      ${left('0')}
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 8px;
    }
  `
);
